export const steps = [
  {
    name: "expertise",
    value: "expertise",
  },
  {
    name: "background",
    value: "background",
  },
  {
    name: "profile",
    value: "profile",
  },
]

export const currencies = [
  {
    name: "USD $",
    value: "USD",
  },
  // {
  //   name: "BDT ৳",
  //   value: "BDT",
  // },
  // {
  //   name: "EUR €",
  //   value: "EUR",
  // },
  // {
  //   name: "INR ₹",
  //   value: "INR",
  // },
  // {
  //   name: "NGN ₦",
  //   value: "NGN",
  // },
  // {
  //   name: "BRL R$",
  //   value: "BRL",
  // },
]

// export const timeZones = [
//   {
//     name: "US/Pacific",
//     value: "US/Pacific",
//   },
//   {
//     name: "US/Mountain",
//     value: "US/Mountain",
//   },
//   {
//     name: "US/Central",
//     value: "US/Central",
//   },
//   {
//     name: "US/Eastern",
//     value: "US/Eastern",
//   },
//   {
//     name: "US/Alaska",
//     value: "US/Alaska",
//   },
//   {
//     name: "US/Hawaii",
//     value: "US/Hawaii",
//   },
//   {
//     name: "Asia/Kolkata",
//     value: "Asia/Kolkata",
//   },
// ]